import './avatar.scss';

export default function Avatar({ icon, color, large, onClick, style }) {
    return (
        <div className={"avatar" + (large ? " large" : "")} onClick={onClick} style={{...style, borderColor: color}}>
            <img className="icon" src={'images/avatar/' + icon} alt="Avatar" />
        </div>
    )
}